import settings from '../../utils/settings';
import { USER_ID, USER_TYPE } from '../../utils/constants';

export interface AuthCookieData {
  id: string;
  type?: string;
}

export const getAuthCookies = (): AuthCookieData | null => {
  const id = settings.getCookie(USER_ID);
  if (!id) return null;
  const type = settings.getCookie(USER_TYPE);
  return { id, type };
};
